import { useState } from 'react';

import { Chip, Menu } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';
import { FormattedMessage, useIntl } from 'react-intl';

import { InviteStatus } from 'services/index';

import { ChevronByParameter } from 'components/ChevronByParameter/ChevronByParameter';

import { statusActions } from './constant';

import { StatusDropdownProps } from './types';

import * as S from './styles';

export const StatusDropdownButton: React.FC<StatusDropdownProps> = ({
  setStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isOpened, setIsOpened] = useState(false);
  const [statusSelected, setStatusSelected] =
    useState<{ key: string; param: InviteStatus | null }>();
  const intl = useIntl();

  return (
    <>
      <Chip
        ref={setAnchorEl}
        onClick={() => setIsOpened(true)}
        onDelete={() => setIsOpened(true)}
        label={intl.formatMessage({
          id: statusSelected
            ? statusSelected.key
            : 'CPPLATFORM.CPINVITEMANAGEMENT.FILTERTITLE',
        })}
        deleteIcon={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <ChevronByParameter
            mode="down"
            opacity={statusSelected ? 0.7 : 0.3}
          />
        }
        color={statusSelected ? 'secondary' : 'default'}
        size="medium"
        variant={statusSelected ? 'filled' : 'outlined'}
      />

      <Menu
        anchorEl={anchorEl}
        open={isOpened}
        onClose={() => setIsOpened(false)}
        onClick={() => setIsOpened(false)}
        sx={{ '& .MuiMenu-paper': { backgroundColor: 'white', width: 220 } }}
      >
        {statusActions.map(item => (
          <S.MenuItem
            key={item.key}
            onClick={() => {
              setStatusSelected(item);
              setStatus(item.param);
              return setIsOpened(false);
            }}
          >
            <div style={{ width: wellzTheme.spacing(1.5) }} />
            <FormattedMessage id={item.key} />
          </S.MenuItem>
        ))}
      </Menu>
    </>
  );
};
